import { Component, OnInit, HostListener, ViewChild } from '@angular/core';
import moment from 'moment';
import { UtilityService } from '../../../core/services/utility.service';
import { EmployeeInfoService } from '../../../core/services/employee-info.service';
import { PortalSettingsService } from '../../../core/services/portal-settings.service';
import { HomeService } from '../services/home.service';
import { EmployeeService } from '../../employee/services/employee.service';
import { Router } from '@angular/router';
import {
  PdfViewerComponent, LinkAnnotationService, BookmarkViewService, MagnificationService,
  ThumbnailViewService, ToolbarService, NavigationService, SignatureFieldSettings,
  AnnotationService, TextSearchService, TextSelectionService, PdfFormFieldBaseModel,
  PrintService, FormDesignerService, FormFieldsService, TextFieldSettings, LoadEventArgs, DownloadStartEventArgs, DownloadEndEventArgs, PrintStartEventArgs, PrintEndEventArgs
} from '@syncfusion/ej2-angular-pdfviewer';

@Component({
  selector: 'app-bulletin',
  templateUrl: './bulletin.component.html',
  styleUrls: ['./bulletin.component.css'],
  providers: [LinkAnnotationService, BookmarkViewService, MagnificationService,
    ThumbnailViewService, ToolbarService, NavigationService, SignatureFieldSettings,
    AnnotationService, TextSearchService, TextSelectionService,
    PrintService, FormDesignerService, FormFieldsService, TextFieldSettings]
})
export class BulletinComponent implements OnInit {
  @ViewChild('signaturePad', { static: false }) signaturePad;
  public pdfviewerControl: PdfViewerComponent;
  portalSettings: any;
  employeeInfo: any;
  //cookieService: any; ToDo: Document dashboard intergration
  format: string;
  formData: { [key: string]: any };
  bulletin: { [key: string]: any };
  files: { [key: string]: any };
  bulletinLoading: boolean;
  bulletinBody: string;
  signed: boolean;
  read: boolean;
  mode: string;
  enableCheckboxSign: boolean;
  previousUrl: string;
  dashboard: string;
  bulletinID: any;
  reqID: any;
  onboardID: any;
  stageID: any;
  routing: any;
  signatureNEmpty: boolean;
  rawImgData: any;
  submitSignImg: string;
  showClickMsg: boolean;
  hideClick: boolean;
  redBorder: boolean;
  alert: string;
  name: string;
  date: any;
  latitude: any;
  longitude: any;
  downloadUrl: string;
  panelWidth: number;
  thumbnailUrl: string;
  applicantDetailUrl: string;
  service: string;
  pdfLoaded: boolean;
  printMode: string = "NewWindow";
  mobileMode: boolean = false;
  pdfResource: string;
  selectedFileIsViewable: boolean;
  selectedAttachmentLink: string;
  signaturePadOptions: Object = {
    'canvasWidth': 510,
    'canvasheight': 150
  }
  private originalFieldStyles: Record<string, TextFieldSettings> = {};
  private originalGetSignatureBackgroundFn: (color: string) => string = (x) => x;

  constructor(portalSettingsService: PortalSettingsService, employeeInfoService: EmployeeInfoService, private homeService: HomeService, private utilityService: UtilityService,
    private employeeService: EmployeeService, private router: Router) {
    this.portalSettings = portalSettingsService.getPortalSettings();
    this.employeeInfo = employeeInfoService.getEmployeeInfo();
    this.format = utilityService.getDateFormat().toUpperCase();
    this.mobileMode = utilityService.isMobileMode();
  }

  ngOnInit(): void {
    this.service = "/Api/PdfViewer";
    this.pdfResource = window.location.origin + "/dist/assets/ej2-pdfviewer-lib";
    this.bulletinLoading = true;
    this.formData = {};
    this.bulletin = {};
    this.files = {};
    this.formData.selectedAttachment = null;
    this.mode = "B";
    this.pdfLoaded = false;
    this.enableCheckboxSign = this.portalSettings.EnableCheckboxSign.ConfigValue == "1" ? true : false;
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;
      });
    }
    this.previousUrl = '';
    var width = $("#modal_size").width();
    this.panelWidth = (width > 550 ? 550 : width) + 30;
    this.utilityService.openModal();
    this.getRouteData();
    this.getPreviousPage();
  }

  public documentStartDownload(args: DownloadStartEventArgs): void {
    const pdfViewer = (<any>document.getElementById('pdfViewer')).ej2_instances[0];
    pdfViewer.enableFormFieldsValidation = false;
  };

  public documentEndDownload(args: DownloadEndEventArgs): void {
    if (!this.bulletin.DisabledRequiredFields) {
      const pdfViewer = (<any>document.getElementById('pdfViewer')).ej2_instances[0];
      pdfViewer.enableFormFieldsValidation = true;
    }
  };

  public documentStartPrint(args: PrintStartEventArgs): void {
    const pdfViewer = (<any>document.getElementById('pdfViewer')).ej2_instances[0];
    pdfViewer.enableFormFieldsValidation = false;
  };

  public documentEndPrint(args: PrintEndEventArgs): void {
    if (!this.bulletin.DisabledRequiredFields) {
      const pdfViewer = (<any>document.getElementById('pdfViewer')).ej2_instances[0];
      pdfViewer.enableFormFieldsValidation = true;
    }
  };  

  getPreviousPage() {
    var routeRegex = /^#[/]Mode[/](.?)[/]Ex[/](true|false?)[/]ID[/](-?\d+)(?:[/]Profile[/](\d+))?$/i;
    var previousUrl = document.referrer;
    var previous = document.cookie.match('(^|;)\\s*' + 'documentURL' + '\\s*=\\s*([^;]+)')?.pop() || '';
    if (previous && previousUrl.indexOf("EditBulletin") != -1) {
      var routeMatch = routeRegex.exec(previous);
      if (routeMatch != null) {
        var bulletinMode = routeMatch[1];
        var hidePast = routeMatch[2];
        var bulletinID = routeMatch[3];

        if (this.bulletinID == -1) {
          bulletinID = this.bulletinID
        }
      }
      this.previousUrl = "/Admin/EditBulletin#/Mode/" + bulletinMode + "/Ex/" + hidePast + "/ID/" + bulletinID;
      this.dashboard = "/Admin/ManageBulletins#/Mode/" + bulletinMode + "/Ex/" + hidePast
    }
  }

  downloadFile(fileAttachmentID) {
    this.downloadUrl = '/Document/GetDBAttachment?attachmentID=' + fileAttachmentID;
  }

  sendAcknowledge() {
    var base64data = null;

    const isPromise = new Promise<any>((resolve, reject) => {
      if (this.pdfLoaded && this.bulletin.EmbedAttachmentInPage && this.bulletin.IsFillablePDF) {
        var pdfviewer = (<any>document.getElementById('pdfViewer')).ej2_instances[0];
        var tempValidatePdfFields = this.validatePdfFields();
        if (tempValidatePdfFields.length > 0 && !this.bulletin.DisabledRequiredFields) {
          this.alert = "Found required fields with no value: " + tempValidatePdfFields.join(", ");
        } else {
          this.restoreOriginalFieldStyles();
          this.restoreInputBordersToBeHidden();
          this.restoreDateFieldInputTypesToUseTextInput();
          pdfviewer.saveAsBlob().then((value) => {
            var data = value;
            var reader = new FileReader();
            reader.readAsDataURL(data);
            reader.onload = () => {
              base64data = reader.result;
              resolve(true);
            };
          })
        }
      } else {
        resolve(true);
      }
    });
    isPromise.then((value) => {
      this.utilityService.openModal();
      var filename = this.bulletin.BulletinHeadline.replace(/[^0-9a-zA-z]/g, " ") + moment().format(this.format).replace(/\//g, "_") + ".pdf";
      setTimeout(() => {
        this.homeService.sendAcknowledge(this.bulletinID, this.bulletin.BulletinAttachDocumentFlagValue, filename, this.bulletin.BulletinSignatureText, (this.bulletin.IsFillablePDF ? base64data.split(";")[1].split(",")[1] : null), (this.bulletin.IsFillablePDF ? this.formData.selectedAttachment?.AttachmentFileName : ''), this.bulletin.IsFillablePDF).then((response: any) => {
          if (this.bulletin.IsStateForm) {
            this.goBack();
          }
          this.homeService.getBulletinsGetIndex(this.bulletinID).then((response: any) => {
            if (response != null) {
              this.bulletin = response[0];
              if (this.bulletin.DateRead != null && (this.bulletin.BulletinMode == "R" || this.bulletin.BulletinMode == "T")) {
                this.read = true;
                this.alert = null;
                this.date = moment(parseInt(this.bulletin.DateRead.substr(6))).utc().format(this.format) + " at " + moment(parseInt(this.bulletin.DateRead.substr(6))).utc().format("hh:mm:ss A");
                this.name = this.bulletin.SignedByName;
              }
              if (this.bulletin.IsFillablePDF)
                this.getAttachmentList();
              this.utilityService.closeModal();
            }
          });
        })
      }, 1000);
    });
  }

  jobReqReturn() {
    var previousSite = document.cookie.match('(^|;)\\s*' + 'documentURL' + '\\s*=\\s*([^;]+)')?.pop() || '';
    if (!previousSite) {
      window.location.href = '/Admin/EditBulletin';

    }
    else {
      window.location.href = '/Admin/EditBulletin' + previousSite.toLowerCase();
    }
  };

  sendONAcknowledge() {
    var base64data = null;

    const isPromise = new Promise<any>((resolve, reject) => {
      if (this.pdfLoaded && this.bulletin.EmbedAttachmentInPage && this.bulletin.IsFillablePDF) {
        var pdfviewer = (<any>document.getElementById('pdfViewer')).ej2_instances[0];
        var tempValidatePdfFields = this.validatePdfFields();
        if (tempValidatePdfFields.length > 0 && !this.bulletin.DisabledRequiredFields) {
          this.alert = "Found required fields with no value: " + tempValidatePdfFields.join(", ");
        } else {
          this.restoreOriginalFieldStyles();
          this.restoreInputBordersToBeHidden();
          this.restoreDateFieldInputTypesToUseTextInput();
          pdfviewer.saveAsBlob().then((value) => {
            var data = value;
            var reader = new FileReader();
            reader.readAsDataURL(data);
            reader.onload = () => {
              base64data = reader.result;
              resolve(true);
            };
          })
        }
      } else {
        resolve(true);
      }
    });
    isPromise.then((value) => {
      this.utilityService.openModal();
      var filename = this.bulletin.BulletinHeadline.replace(/[^0-9a-zA-z]/g, " ") + moment().format(this.format).replace(/\//g, "_") + ".pdf";
      setTimeout(() => {
        this.homeService.sendAcknowledge(this.bulletinID, null, filename, this.bulletin.BulletinSignatureText, (this.bulletin.IsFillablePDF ? base64data.split(";")[1].split(",")[1] : null), (this.bulletin.IsFillablePDF ? this.formData.selectedAttachment?.AttachmentFileName : ''), this.bulletin.IsFillablePDF).then((response: any) => {
          if (response.success) {
            this.router.navigate(['/careers/tasks']);
          }
        })
      }, 1000);
    });
  }

  getRouteData() {
    var applicantRegex = /#(?:([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})[/]([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})[/](-?\d+))[/](AS|RD)$/i;
    var applicantMatch = applicantRegex.exec(window.location.hash);
    if (applicantMatch != null) {
      this.reqID = applicantMatch[1];
      this.onboardID = applicantMatch[2];
      this.stageID = applicantMatch[3];
      this.routing = applicantMatch[4];
    } else {
      applicantRegex = /#([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})$/i;
      applicantMatch = applicantRegex.exec(window.location.hash);
      if (applicantMatch != null) {
        this.onboardID = applicantMatch[1];
      }
    }

    var path = window.location.pathname;
    var routeRegex = /[/]bulletin[/](\d+)/i;
    var altRegex = /[/]onboardingdocument[/](\d+)/i;
    var routeMatch = routeRegex.exec(path);
    var altMatch = altRegex.exec(path);
    if (routeMatch != null) {
      this.bulletinID = routeMatch[1];
      this.getBulletin();
    }
    else if (altMatch != null) {
      this.mode = "O";
      this.bulletinID = altMatch[1];
      this.getBulletin();
    }
    else {
      this.bulletinLoading = false;
    }

    this.applicantDetailUrl = "/Hiring/ApplicantDetail/#" + this.reqID + "/" + this.onboardID + "/" + this.stageID + "/" + this.routing;
  }

  getBulletin() {
    this.homeService.getBulletinsGetIndex(this.bulletinID, this.onboardID).then((response: any) => {
      this.signed = false;
      this.read = false;
      this.bulletin = response[0];
      this.thumbnailUrl = "/Document/GetDBAttachment?attachmentID=" + this.bulletin.BulletinThumbFileAttachmentID
      if (this.bulletin.DateSigned == null && this.bulletin.BulletinMode == "S") {
        this.alert = "This document is awaiting your signature. Please review and sign using the pad at the bottom.";
      } else if (this.bulletin.DateSigned != null && (this.bulletin.BulletinMode == "S" || this.bulletin.BulletinMode == "U")) { //handle US and AU format
        this.signed = true;
        this.date = moment(parseInt(this.bulletin.DateSigned.substr(6))).utc().format(this.format) + " at " + moment(parseInt(this.bulletin.DateSigned.substr(6))).utc().format("hh:mm:ss A");
        this.name = this.bulletin.SignedByName;
        if (this.bulletin.SignatureImage != null) {
          this.bulletin.img = "data:image/png;base64," + this.bulletin.SignatureImage;
        }
      }

      if (this.bulletin.DateRead != null && (this.bulletin.BulletinMode == "R" || this.bulletin.BulletinMode == "T")) {
        this.read = true;
        this.date = moment(parseInt(this.bulletin.DateRead.substr(6))).utc().format(this.format) + " at " + moment(parseInt(this.bulletin.DateRead.substr(6))).utc().format("hh:mm:ss A");
        this.name = this.bulletin.SignedByName;
      } else if (this.bulletin.DateRead == null && this.bulletin.BulletinMode == "R") {
        this.alert = "This document is awaiting your acknowledgement. Please review and acknowledge by clicking the button at the bottom of the page.";
      }
      this.bulletinBody = this.bulletin.BulletinBody;
      this.bulletinLoading = false;
      this.getAttachmentList();
    });
  }

  getAttachmentList() {
    var tempModuleID = (this.bulletin.BulletinResponseID != null && this.bulletin.IsFillablePDF ? 129 : 28);
    var tempRecordID = (this.bulletin.BulletinResponseID != null && this.bulletin.IsFillablePDF ? this.bulletin.BulletinResponseID : this.bulletinID);
    this.homeService.getDBAttachmentList(tempModuleID, tempRecordID, null, this.mode == "O").then((response: any) => {
      if (response != null) {
        this.files = response;
        this.formData.selectedAttachment = this.files[0];
        if (this.bulletin.EmbedAttachmentInPage && this.formData.selectedAttachment != null) {
          this.loadPreview();
        }else
          this.utilityService.closeModal();
      }
    });
  }

  loadPreview () {
    this.selectedFileIsViewable = !this.utilityService.fileIsNotViewable(this.formData.selectedAttachment.AttachmentFileName);
    if (this.selectedFileIsViewable) {
      this.utilityService.openModal();
      let flattenPDF = this.bulletin.DateSigned != null && !this.bulletin.HasOnboardDocViewPermission;
      this.homeService.getPdfData(this.formData.selectedAttachment.FileAttachmentID, flattenPDF, this.bulletin.DisabledRequiredFields).then((response: any) => {
        var pdfviewer = (<any>document.getElementById('pdfViewer')).ej2_instances[0];
        setTimeout(() => {
          pdfviewer.enableFormFieldsValidation = this.bulletin.DisabledRequiredFields;
          pdfviewer.toolbar.showToolbarItem(new Array("SubmitForm"), false);
          pdfviewer.toolbar.showToolbarItem(new Array("OpenOption"), false);
          pdfviewer.toolbar.showToolbarItem(new Array("AnnotationEditTool"), (this.bulletin.BulletinResponseID != null ? true : false));
          pdfviewer.toolbar.showToolbarItem(new Array("PrintOption"), true);
          if (this.bulletin.BulletinIsSecure) {
            pdfviewer.toolbar.showToolbarItem(new Array("DownloadOption"), false);
            pdfviewer.toolbar.showToolbarItem(new Array("PrintOption"), false);
            pdfviewer.enablePrint = false;
          }
          pdfviewer.toolbar.showToolbarItem(new Array("FormDesignerEditTool"), false);
          if (!this.mobileMode) {
            pdfviewer.toolbar.showToolbarItem(new Array("CommentTool"), false);
            pdfviewer.toolbar.showToolbarItem(new Array("UndoRedoTool"), false);
          }
          pdfviewer.documentPath = "data:application/pdf;base64," + response;
          pdfviewer.downloadFileName = this.formData.selectedAttachment.AttachmentFileName.substring(0, this.formData.selectedAttachment.AttachmentFileName.indexOf('.')) + ".pdf";
          this.pdfLoaded = true;
          this.utilityService.closeModal();
        }, 2000);
      })
    } else {
      this.selectedAttachmentLink = `/Document/GetDBAttachment?attachmentID=${this.formData.selectedAttachment.FileAttachmentID}`;
      this.utilityService.closeModal();
    }
  }

  public documentLoaded(e: LoadEventArgs): void {
    if (this.bulletin.DateSigned == null || (this.bulletin.HasSecondReviewStep && this.bulletin.SecondStepSubmitDate == null)) {
      this.fixSyncFusionBackgroundColorLogic();
      this.storeOriginalFieldStyles();
      this.updateDateFieldInputTypesToUseDateInput();
      this.useNormalStylesOnAllFields();
    }
  }

  private useNormalStylesOnAllFields(): void {
    var pdfviewer = (<any>document.getElementById('pdfViewer')).ej2_instances[0];

    pdfviewer.formFieldCollection.forEach(field => {
      const updatedStyles = { backgroundColor: "#daeaf7" } as TextFieldSettings;
      if (field.isRequired && !field.isReadOnly) {
        updatedStyles.borderColor = "#ff0000";
      }
      this.applyFieldStyles(field.id, updatedStyles);
    });
  }

  // custom validation of pdf forms since the form is not submitted via the pdfviewer component
  private validatePdfFields(): string[] {
    var pdfviewer = (<any>document.getElementById('pdfViewer')).ej2_instances[0];
    var allRequiredFields = pdfviewer.retrieveFormFields();
    var requiredFieldsWithNoValue = this.getRequiredFieldsWithNoValue(allRequiredFields);
    var existingFields = {};
    const requiredFields = pdfviewer.formFields.filter(x => x.isRequired && !x.isReadOnly);
      requiredFields.forEach(y => {
        existingFields[y.id] = true;
      });
    allRequiredFields.filter(i => i.isRequired && !i.isReadOnly).forEach(x => {
      if (x.type != "Checkbox" && x.type != "DropdownList") {
        let hasValue = !!x.value;
        if (x.type === PdfFieldType.RadioButton) {
          hasValue = allRequiredFields.filter(field => field.name === x.name).some(field => field.isSelected);
        }
        if (hasValue) {
          if (existingFields[x.id])
            this.applyFieldStyles(x.id as string, { backgroundColor: "#daeaf7" });
        } else {
          if (existingFields[x.id])
            this.applyFieldStyles(x.id as string, { backgroundColor: "#ff000060" });

          if (!requiredFieldsWithNoValue.some(field => field.name === x.name)) {
            requiredFieldsWithNoValue.push(x);
          }
        }
      } else if (x.type == "Checkbox") {
        if (!x.isChecked) {
          if (existingFields[x.id])
            this.applyFieldStyles(x.id as string, { backgroundColor: "#ff000060" });

          if (!requiredFieldsWithNoValue.some(field => field.name === x.name)) {
            requiredFieldsWithNoValue.push(x);
          }
        } else {
          if (existingFields[x.id])
            this.applyFieldStyles(x.id as string, { backgroundColor: "#daeaf7" });
        }
      } else if (x.type == "DropdownList"){
        if (!x.selectedIndex) {
          if (existingFields[x.id])
            this.applyFieldStyles(x.id as string, { backgroundColor: "#ff000060" });

          if (!requiredFieldsWithNoValue.some(field => field.name === x.name)) {
            requiredFieldsWithNoValue.push(x);
          }
        } else {
          if (existingFields[x.id])
            this.applyFieldStyles(x.id as string, { backgroundColor: "#daeaf7" });
        }
      }
    });
    const NamesOfRequiredFieldsWithNoValue = Array.from(new Set(requiredFieldsWithNoValue.map(field => field.name)));
    return NamesOfRequiredFieldsWithNoValue;
  }

  private getRequiredFieldsWithNoValue (requiredFields) {
    const radioGroups = {};
    let requiredFieldsWithNoValue = [];
    requiredFields.forEach(field => {
      if (((["Textbox", "Password", "InitialField", "SignatureField"].includes(field.type) && field.value == "")
        || (field.type == "Checkbox" && field.isChecked == false)) && field.isRequired && !field.isReadOnly) {
        requiredFieldsWithNoValue.push(field)
      } else if (field.type == "RadioButton" && field.isRequired && !field.isReadOnly) {
        radioGroups[field.name] = radioGroups[field.name] ? radioGroups[field.name] : [];
        radioGroups[field.name].push(field);
      }
    })

    Object.keys(radioGroups).forEach(group => {
      let isSelected = false;
      radioGroups[group].forEach(radioButton => {
        if (radioButton.isSelected) {
          isSelected = true;
        }
      })
      if (!isSelected) {
        requiredFieldsWithNoValue = requiredFieldsWithNoValue.concat(radioGroups[group])
      }
    })

    return requiredFieldsWithNoValue;
  }

  checkSigned() {
    if (this.signaturePad.isEmpty()) {
      this.redBorder = true;
    } else {
      this.signatureNEmpty = true;
      this.redBorder = false;
    }
  }

  clear() {
    if (this.signaturePad != null) {
      this.signaturePad.clear();
    }
    this.signatureNEmpty = false;
    this.rawImgData = null;
    this.submitSignImg = null;
    this.formData.typeSign = false;
    this.showClickMsg = false;
    this.hideClick = false;
  }

  submit() {
    var base64data = null;

    const isPromise = new Promise<any>((resolve, reject) => {
      if (this.pdfLoaded && this.bulletin.EmbedAttachmentInPage && this.bulletin.IsFillablePDF) {
        var pdfviewer = (<any>document.getElementById('pdfViewer')).ej2_instances[0];
        var tempValidatePdfFields = this.validatePdfFields();
        if (tempValidatePdfFields.length > 0 && !this.bulletin.DisabledRequiredFields) {
          this.alert = "Found required fields with no value: " + tempValidatePdfFields.join(", ");
        } else {
          this.restoreOriginalFieldStyles();
          this.restoreInputBordersToBeHidden();
          this.restoreDateFieldInputTypesToUseTextInput();
          pdfviewer.saveAsBlob().then((value) => {
            var data = value;
            var reader = new FileReader();
            reader.readAsDataURL(data);
            reader.onload = () => {
              base64data = reader.result;
              resolve(true);
            };
          })
        }
      } else {
        resolve(true);
      }
    });
    isPromise.then((value) => {
      this.utilityService.openModal();
      this.checkSigned();
      if (this.signatureNEmpty && this.bulletin.DateSigned == null || this.formData.typeSign) {
        var filename = this.bulletin.BulletinHeadline.replace(/[^0-9a-zA-z]/g, " ") + moment().format(this.format).replace(/\//g, "_") + ".pdf";
        var dataURL = this.signaturePad.toDataURL().replace(/^data:image\/(png|jpg);base64,/, "");
        setTimeout(() => {
          this.homeService.sentBulletinSign(this.bulletinID, this.bulletin.BulletinAttachDocumentFlagValue, this.formData.typeSign ? this.rawImgData : dataURL, this.bulletin.BulletinSignatureText
            , (this.latitude != null ? this.latitude : null), (this.longitude != null ? this.longitude : null), filename, (this.bulletin.IsFillablePDF ? base64data.split(";")[1].split(",")[1] : null), (this.bulletin.IsFillablePDF ? this.formData.selectedAttachment?.AttachmentFileName : ''), this.bulletin.IsFillablePDF).then((response: any) => {
              if (response.success) {
                this.alert = null;
                if (this.bulletin.IsStateForm) {
                  this.goBack();
                }
                this.homeService.getBulletinsGetIndex(this.bulletinID).then((response: any) => {
                  this.bulletin = response[0];
                  if (this.bulletin.DateSigned != null && this.bulletin.BulletinMode == "S") { //handle US and AU format
                    this.signed = true;
                    this.date = moment(parseInt(this.bulletin.DateSigned.substr(6))).utc().format(this.format) + " at " + moment(parseInt(this.bulletin.DateSigned.substr(6))).utc().format("hh:mm:ss A");
                    this.name = this.bulletin.SignedByName;
                    if (this.bulletin.SignatureImage != null) {
                      this.bulletin.img = "data:image/png;base64," + this.bulletin.SignatureImage;
                    }
                  }
                  if (this.bulletin.IsFillablePDF)
                    this.getAttachmentList();
                  this.utilityService.closeModal();
                });
              } else {
                this.utilityService.closeModal();
              }
            })
        }, 1000);
      } else {
        this.utilityService.closeModal();
      }
    });
  }

  submitON() {
    var base64data = null;

    const isPromise = new Promise<any>((resolve, reject) => {
      if (this.pdfLoaded && this.bulletin.EmbedAttachmentInPage && this.bulletin.IsFillablePDF) {
        var pdfviewer = (<any>document.getElementById('pdfViewer')).ej2_instances[0];
        var tempValidatePdfFields = this.validatePdfFields();
        if (tempValidatePdfFields.length > 0 && !this.bulletin.DisabledRequiredFields) {
          this.alert = "Found required fields with no value: " + tempValidatePdfFields.join(", ");
        } else {
          this.restoreOriginalFieldStyles();
          this.restoreInputBordersToBeHidden();
          this.restoreDateFieldInputTypesToUseTextInput();
          pdfviewer.saveAsBlob().then((value) => {
            var data = value;
            var reader = new FileReader();
            reader.readAsDataURL(data);
            reader.onload = () => {
              base64data = reader.result;
              resolve(true);
            };
          })
        }
      } else {
        resolve(true);
      }
    });
    isPromise.then((value) => {
      this.utilityService.openModal();
      this.checkSigned();
      if (this.signatureNEmpty && this.bulletin.DateSigned == null || this.formData.typeSign) {
        var filename = this.bulletin.BulletinHeadline.replace(/[^0-9a-zA-z]/g, " ") + moment().format(this.format).replace(/\//g, "_") + ".pdf";
        var dataURL = this.signaturePad.toDataURL().replace(/^data:image\/(png|jpg);base64,/, "");
        setTimeout(() => {
          this.homeService.sentBulletinSign(this.bulletinID, null, this.formData.typeSign ? this.rawImgData : dataURL, this.bulletin.BulletinSignatureText
            , (this.latitude != null ? this.latitude : null), (this.longitude != null ? this.longitude : null), filename, (this.bulletin.IsFillablePDF ? base64data.split(";")[1].split(",")[1] : null), (this.bulletin.IsFillablePDF ? this.formData.selectedAttachment?.AttachmentFileName : ''), this.bulletin.IsFillablePDF).then((response: any) => {
              if (response.success) {
                this.router.navigate(['/careers/tasks']);
              }
            })
        }, 1000);
      } else {
        this.utilityService.closeModal();
      }
    });
  }

  clickSign(type: any) {
    if (this.signaturePad.isEmpty()) {
      this.formData.typeSign = true;
      this.homeService.getTypeSign(type).then((response: any) => {
        this.rawImgData = response;
        this.submitSignImg = "data:image/png;base64," + response;
      });
      this.hideClick = true;
      this.showClickMsg = false;
    } else {
      this.showClickMsg = true;
    }
  }

  public secondSubmit() {
    var base64data = null;

    const isPromise = new Promise<any>((resolve, reject) => {
      if (this.pdfLoaded && this.bulletin.EmbedAttachmentInPage && this.bulletin.IsFillablePDF) {
        var pdfviewer = (<any>document.getElementById('pdfViewer')).ej2_instances[0];
        var tempValidatePdfFields = this.validatePdfFields();
        if (tempValidatePdfFields.length > 0 && !this.bulletin.DisabledRequiredFields) {
          this.alert = "Found required fields with no value: " + tempValidatePdfFields.join(", ");
        } else {
          this.restoreOriginalFieldStyles();
          this.restoreInputBordersToBeHidden();
          this.restoreDateFieldInputTypesToUseTextInput();
          pdfviewer.saveAsBlob().then((value) => {
            var data = value;
            var reader = new FileReader();
            reader.readAsDataURL(data);
            reader.onload = () => {
              base64data = reader.result;
              resolve(true);
            };
          })
        }
      } else {
        resolve(true);
      }
    });
    isPromise.then((value) => {
      this.utilityService.openModal();
      this.employeeService.secondStepSubmit(this.bulletin.BulletinResponseID, (this.bulletin.IsFillablePDF ? base64data.split(";")[1].split(",")[1] : null)).then((response: any) => {
        if (response.success) {
          this.homeService.getBulletinsGetIndex(this.bulletinID, this.onboardID).then((response: any) => {
            if (response != null) {
              this.bulletin = response[0];
              if (this.bulletin.DateRead != null && (this.bulletin.BulletinMode == "R" || this.bulletin.BulletinMode == "T")) {
                this.read = true;
                this.alert = null;
                this.date = moment(parseInt(this.bulletin.DateRead.substr(6))).utc().format(this.format) + " at " + moment(parseInt(this.bulletin.DateRead.substr(6))).utc().format("hh:mm:ss A");
                this.name = this.bulletin.SignedByName;
              }
              if (this.bulletin.DateSigned != null && (this.bulletin.BulletinMode == "S" || this.bulletin.BulletinMode == "U")) { //handle US and AU format
                this.signed = true;
                this.date = moment(parseInt(this.bulletin.DateSigned.substr(6))).utc().format(this.format) + " at " + moment(parseInt(this.bulletin.DateSigned.substr(6))).utc().format("hh:mm:ss A");
                this.name = this.bulletin.SignedByName;
                if (this.bulletin.SignatureImage != null) {
                  this.bulletin.img = "data:image/png;base64," + this.bulletin.SignatureImage;
                }
              }
              if (this.bulletin.IsFillablePDF)
                this.getAttachmentList();
              this.utilityService.closeModal();
            }
          });
        }
      })
    });
  }

  goBack() {
    window.history.go(-1);
  }

  private fixSyncFusionBackgroundColorLogic() {
    var pdfviewer = (<any>document.getElementById('pdfViewer')).ej2_instances[0];
    this.originalGetSignatureBackgroundFn = pdfviewer.formDesigner.getSignatureBackground;
    pdfviewer.formDesigner.getSignatureBackground = x => x;
  }


  private updateDateFieldInputTypesToUseDateInput() {
    var pdfviewer = (<any>document.getElementById('pdfViewer')).ej2_instances[0];
    const dateFields = pdfviewer.formFields.filter(x => (x.name ?? '').toLowerCase().indexOf("datepicker") >= 0 && !x.isMultiline);
    dateFields.forEach(x => {
      (window.document.getElementById(x.id!) as HTMLInputElement).type = HtmlInputType.date;
    });
  }

  private restoreDateFieldInputTypesToUseTextInput() {
    var pdfviewer = (<any>document.getElementById('pdfViewer')).ej2_instances[0];
    const dateFields = pdfviewer.formFields.filter(x => (x.name ?? '').toLowerCase().indexOf("datepicker") >= 0 && !x.isMultiline);
    dateFields.forEach(x => {
      const dateEl = window.document.getElementById(x.id!) as HTMLInputElement;
      dateEl.type = HtmlInputType.text;
      const dateRegex = /^(\d{4})-(\d{2})-(\d{2})$/;
      const dateMatch = dateEl.value.match(dateRegex);
      if (dateMatch) {
        const [dateStr, year, month, day] = dateMatch;
        dateEl.value = `${month}/${day}/${year}`;
      }
    });
  }

  private restoreInputBordersToBeHidden() {
    var pdfviewer = (<any>document.getElementById('pdfViewer')).ej2_instances[0];
    pdfviewer.formFieldCollection
      .filter(x => x.formFieldAnnotationType === PdfFieldType.Textbox || x.formFieldAnnotationType === PdfFieldType.Signature)
      .forEach(x => {
        this.applyFieldStyles(x.id, { borderColor: "#ffffff00" });
      });
  }

  private storeOriginalFieldStyles() {
    var pdfviewer = (<any>document.getElementById('pdfViewer')).ej2_instances[0];
    pdfviewer.formFieldCollection.forEach((field: PdfFormFieldBaseModel) => {
      if (!field.id) return;
      // Copy the existing styles (important to use a copy and not original object as that will change)
      const pdfFieldStyles: TextFieldSettings = Object.assign({}, this.getFieldStyles(field.id));
      this.originalFieldStyles[field.id] = pdfFieldStyles;
    });
  }

  private restoreOriginalFieldStyles() {
    var pdfviewer = (<any>document.getElementById('pdfViewer')).ej2_instances[0];
    pdfviewer.formFieldCollection.forEach(field => {
      const fieldStyles = this.originalFieldStyles[field.id];
      if (!fieldStyles) return;
      this.applyFieldStyles(field.id, fieldStyles);
    });
  }

  private applyFieldStyles(fieldId: string, newStyles: Partial<TextFieldSettings>) {
    var pdfviewer = (<any>document.getElementById('pdfViewer')).ej2_instances[0];
    const field = pdfviewer.formDesigner.getFormField(fieldId);
    const fieldStyles = this.getFieldStyles(fieldId);
    const styles: TextFieldSettings = Object.assign({}, fieldStyles, newStyles as TextFieldSettings);
    if (field.formFieldAnnotationType === PdfFieldType.Signature) {
      styles.backgroundColor = this.originalGetSignatureBackgroundFn(styles.backgroundColor);
    }
    pdfviewer.formDesignerModule.updateFormField(fieldId, styles);
  }

  private getFieldStyles(fieldId: string): TextFieldSettings {
    var pdfviewer = (<any>document.getElementById('pdfViewer')).ej2_instances[0];
    const field = pdfviewer.formDesignerModule.getFormField(fieldId);
    // Getting background color is tricky b/c SyncFusion alters the Hex background color alpha component to always be hex "60".
    // This code uses the full opacity for background color, which is hex "ff".
    let backgroundColor = field.backgroundColor;
    const regexHexWithAlpha = /^(#[0-9A-Fa-f]{6})(60)$/
    const backgroundColorMatch = backgroundColor?.match(regexHexWithAlpha);
    if (backgroundColorMatch) {
      const [_fullBgColorStr, bgNoAlpha] = backgroundColorMatch;
      backgroundColor = `${bgNoAlpha}ff`;
    }
    return {
      alignment: field.alignment,
      backgroundColor,
      borderColor: field.borderColor,
      color: field.color,
      font: field.font,
      fontFamily: field.fontFamily,
      fontSize: field.fontSize,
      fontStyle: field.fontStyle,
      opacity: field.opacity,
      rotateAngle: field.rotateAngle,
      signatureIndicatorSettings: field.signatureIndicatorSettings,
      thickness: field.thickness,
      visibility: field.visibility,
      zIndex: field.zIndex,
    } as unknown as TextFieldSettings
  }
}

enum PdfFieldType {
  Textbox = "Textbox",
  Signature = "SignatureField",
  RadioButton = "RadioButton",
}

enum HtmlInputType {
  text = "text",
  date = "date",
}